export default "__VITE_ASSET__ee6884ad__"